<template>
  <v-dialog :value="value" max-width="520" :content-class="stacked ? 'dialog-stack-2' : ''" @input="$emit('input', $event)">
    <div v-if="detail" class="pb-dialog upgrade">
      <div class="pb-dialog-head">
        <PlanChip :plan="target" />
        <button type="button" class="pb-icon-button" aria-label="Close" @click="close"><i class="mdi mdi-close" aria-hidden="true"></i></button>
      </div>
      <h2>{{ parts.heading }}</h2>
      <p v-if="parts.body">{{ parts.body }}</p>
      <template v-if="lines.length">
        <p class="upgrade-adds">{{ targetLabel }}, {{ price }} a month, adds:</p>
        <ul class="upgrade-perks">
          <li v-for="line in lines" :key="line"><i class="mdi mdi-check" aria-hidden="true"></i>{{ line }}</li>
        </ul>
      </template>
      <!-- Billing is the owner's: a teammate sees the same lock, and who to ask. -->
      <div v-if="buyer" class="pb-dialog-actions">
        <router-link to="/plans" class="pb-button ghost" @click.native="close">Compare plans</router-link>
        <router-link :to="{ path: '/subscribe', query: { plan: target } }" class="pb-button" @click.native="close">See {{ targetLabel }}</router-link>
      </div>
      <div v-else class="pb-dialog-actions upgrade-ask">
        <p>Ask the workspace owner{{ ownerEmail ? ' (' + ownerEmail + ')' : '' }} about {{ targetLabel }}.</p>
        <button type="button" class="pb-button" @click="close">OK</button>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import PlanChip from './PlanChip.vue';
import { COUNTED_UNITS, LOCKED_FEATURES, monthlyPrice, planLabel, upgradeLines } from '../lib/plans';

export default {
  name: 'UpgradeDialog',
  components: { PlanChip },
  props: {
    value: { type: Boolean, default: false },
    // {feature} from a locked control, {feature, used} from a reached cap, or the API's 402 plan_limit detail
    // ({message, upgrade_to, limit}).
    detail: { type: Object, default: null },
    // Open over another dialog: the shared dialog-stack-2 layer dims the one beneath.
    stacked: { type: Boolean, default: false }
  },
  computed: {
    matrix() { return this.$store.getters['praiseboard/planMatrix']; },
    plan() { return this.$store.getters['praiseboard/plan']; },
    feature() { return (this.detail && (this.detail.feature || this.detail.limit)) || ''; },
    target() {
      const detail = this.detail || {};
      return detail.upgrade_to || (this.feature && this.$store.getters['praiseboard/availableOn'](this.feature))
        || this.$store.getters['praiseboard/nextPlan'] || 'solo';
    },
    targetLabel() { return planLabel(this.matrix, this.target); },
    price() { return monthlyPrice(this.matrix, this.target); },
    lines() { return upgradeLines(this.matrix, this.plan, this.target, this.feature); },
    // Before a workspace exists the account is its own owner.
    buyer() { return this.$store.getters['praiseboard/isOwner'] || !this.$store.getters['praiseboard/hasWorkspace']; },
    ownerEmail() { const data = this.$store.getters['praiseboard/data']; return (data && data.owner_email) || ''; },
    parts() {
      const detail = this.detail || {};
      if (detail.message) {
        const match = String(detail.message).match(/^(.+?[.?!])\s+(.+)$/);
        return match ? { heading: match[1], body: match[2] } : { heading: String(detail.message), body: '' };
      }
      const entry = LOCKED_FEATURES[this.feature];
      const allowed = this.$store.getters['praiseboard/limits'][this.feature];
      const unit = COUNTED_UNITS[this.feature];
      if (entry && unit && detail.used !== undefined && typeof allowed === 'number') {
        return { heading: planLabel(this.matrix, this.plan) + ' includes ' + allowed + ' ' + unit[allowed === 1 ? 0 : 1] + '.', body: entry.about };
      }
      return entry ? { heading: entry.label, body: entry.about } : { heading: 'Available on ' + this.targetLabel, body: '' };
    }
  },
  methods: {
    close() { this.$emit('input', false); }
  }
};
</script>

<style scoped>
.upgrade h2{margin-top:4px}
.upgrade-adds{margin:18px 0 0;font:600 14px/1.4 var(--font-body);color:#1F2328}
.upgrade-perks{list-style:none;margin:10px 0 0;padding:0;display:flex;flex-direction:column;gap:8px}
.upgrade-perks li{display:flex;gap:10px;align-items:flex-start;color:#1F2328;font-size:14.5px;line-height:1.45}
.upgrade-perks .mdi{color:#2F7D4F;font-size:18px;line-height:1.2}
.upgrade-ask{align-items:center}
.upgrade-ask p{flex:1 1 220px;margin:0;color:#4F4A45;font-size:14.5px;line-height:1.45}
</style>
